import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Box,
} from '@mui/material';

const ParentDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { parent } = location.state || {};

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 3 }}>
          {parent?.parentName || 'Unknown Parent'}
        </Typography>
        <Card sx={{ p: 2, mb: 3, boxShadow: 3, bgcolor: '#fff' }}>
          <CardContent>
            <Typography sx={{ color: '#666', mb: 1 }}>ID Number: {parent?.idNumber || 'N/A'}</Typography>
            <Typography sx={{ color: '#666', mb: 1 }}>Contact: {parent?.contactNumber || 'N/A'}</Typography>
            <Typography sx={{ color: '#666', mb: 1 }}>Email: {parent?.email || 'N/A'}</Typography>
            <Typography sx={{ color: '#666', mb: 1 }}>Gender: {parent?.gender || 'N/A'}</Typography>
            <Typography sx={{ color: '#666', mb: 1 }}>Relationship: {parent?.relationship || 'N/A'}</Typography>
            <Typography sx={{ color: '#666', mb: 1 }}>Learner: {parent?.learnerName || 'N/A'}</Typography>
            <Typography sx={{ color: '#666', mb: 1 }}>Learner Class: {parent?.learnerClass || 'N/A'}</Typography>
            <Typography sx={{ color: '#666', mb: 1 }}>Learner Admission: {parent?.learnerAdmissionNumber || 'N/A'}</Typography>
          </CardContent>
        </Card>
        <Box sx={{ mt: 3 }}>
          <Button
            variant="contained"
            sx={{ bgcolor: '#6200ee' }}
            onClick={() =>
              navigate('/chat', {
                state: {
                  senderId: parent?._id,
                  receiverId: parent?.schoolId,
                  senderName: parent?.parentName,
                  receiverName: 'School',
                },
              })
            }
          >
            Chat with Parent
          </Button>
        </Box>
      </motion.div>
    </Container>
  );
};

export default ParentDetails;